export const UPDATE_ALBUM_FILTER = 'admin-css/UPDATE_ALBUM_FILTER';
export const TOGGLE_ALBUM_SORT_OPTION = 'admin-css/TOGGLE_ALBUM_SORT_OPTION';
export const TOGGLE_ALBUM_SORT_OPTION_DIRECTION =
  'admin-css/TOGGLE_ALBUM_SORT_OPTION_DIRECTION';

export const updateAlbumsFilter = (filter = {}) => ({
  type: UPDATE_ALBUM_FILTER,
  filter,
});

export const toggleAlbumsSortOption = option => ({
  type: TOGGLE_ALBUM_SORT_OPTION,
  option,
});
export const toggleAlbumsSortOptionDirection = option => ({
  type: TOGGLE_ALBUM_SORT_OPTION_DIRECTION,
  option,
});
